import _ from 'lodash';
import React from 'react';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import useGetAssetClasses from '../../../../services/funds/asset-classes-service';
import { useIsMobile, useIsMobileOrTablet } from '../../../../shared/theme';
import useFundsStateStore from '../../common/funds-state-hook';
import { urlToSearchCriteria } from '../../common/utils';
import Desktop from './asset-class-filter-components/desktop';
import Mobile from './asset-class-filter-components/mobile';

export default function AssetClassFilter() {
  const isMobile = useIsMobile();
  const isMobileOrTablet = useIsMobileOrTablet();
  const set = useFundsStateStore(state => state.set);
  const showAssetClassFilterHint = useFundsStateStore(state => state.showAssetClassFilterHint);
  const assetClasses = useFundsStateStore(state => state.assetClasses);
  const filteredAssetClasses = useFundsStateStore(state => state.filters.assetClasses);
  const appliedFilterAssetClasses = useFundsStateStore(state => state.appliedFilters.assetClasses);
  const appliedFilterFundTypes = useFundsStateStore(state => state.appliedFilters.fundTypes);
  const filterName = useFundsStateStore(state => state.filters.name);
  const filterCount = filteredAssetClasses.length;
  const searchCriteria = urlToSearchCriteria();
  const type = appliedFilterFundTypes[0] || searchCriteria.type;
  const [, get] = useGetAssetClasses(type, searchCriteria.series, filterName);
  const [showOptions, setShowOptions] = React.useState(false);

  useChangeAwareEffect(({ did, isMount }) => {
    (isMount || did.filterName.change || did.type.change) && get().then(({ data }) => {
      const newAssetClasses = _.get(data, 'assetClasses', []);
      const newAppliedFilteredAssetClasses = _.filter(appliedFilterAssetClasses, id => (
        _.find(newAssetClasses, { id })
      ));
      set(state => {
        state.assetClasses = newAssetClasses;
        state.filters.assetClasses = newAppliedFilteredAssetClasses;
        state.appliedFilters.assetClasses = newAppliedFilteredAssetClasses;
      });

      if (showAssetClassFilterHint && !isMobileOrTablet) {
        setShowOptions(true);
      }
    });
  }, { filterName, type });

  const clearFilter = () => (
    set(state => {
      state.filters.assetClasses = [];
    })
  );

  const applyFilter = e => {
    e && e.preventDefault();
    setShowOptions(false);

    if (showAssetClassFilterHint) {
      set(state => {
        state.showAssetClassFilterHint = false;
      });
    }

    if (_.xor(filteredAssetClasses, appliedFilterAssetClasses).length > 0) {
      set(state => {
        state.filterChanged = true;
        state.appliedFilters.assetClasses = [...filteredAssetClasses];
      });
    }
    sessionStorage.setItem('userChangedFilterCondition', 'true');
  };

  const onClick = () => {
    if (showOptions) {
      applyFilter();
    } else {
      if (showAssetClassFilterHint) {
        set(state => {
          state.showAssetClassFilterHint = false;
        });
      }
      setShowOptions(true);
    }
  };

  const onClose = () => {
    setShowOptions(false);
    set(state => {
      state.filterChanged = false;
      state.filters.assetClasses = [...appliedFilterAssetClasses];
    });
  };

  /* eslint-disable no-nested-ternary */
  const label = filterCount === 0 ? 'Asset Class' : filterCount === 1 ? '1 Asset Class' : `${filterCount} Asset Classes`;
  const className = showOptions ? 'focus' : appliedFilterAssetClasses.length > 0 ? 'active' : '';
  /* eslint-enable no-nested-ternary */

  const Component = isMobile ? Mobile : Desktop;

  return (
    <Component
      showOptions={showOptions}
      dropdownLabel={label}
      dropdownClassName={className}
      clearFilter={clearFilter}
      applyFilter={applyFilter}
      onClick={onClick}
      assetClasses={assetClasses}
      filterCount={filterCount}
      onClose={onClose}
    />
  );
}
